import axios from 'axios'
// import {message} from "ant-design-vue";
import store from '@/store'
import router from '@/router';
import { getCookie, delCookie ,setCookie,IsIPMode,setPersistenceCookie} from '@/utils/cookie';
import { console } from 'vuedraggable/src/util/helper'

// message.config({
//     maxCount: 1,
// });

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers = {
        'appDomainName': window.location.origin,
        'x-requested-with': 'XMLHttpRequest',
    }
    //不需要token
    // if (getCookie("userInfo") && getCookie("userInfo").token) {
    //     config.headers.Authorization = `Bearer ` + getCookie("userInfo").token
    // }

    let appKey = decodeURIComponent(router.app._route.query.appKey)
   if ( IsIPMode()) {
       //如果是IP模式

     if (appKey.indexOf("?") != -1) {    //判断是否有参数
       let appKeyArry = appKey.split("?");
        appKey = appKeyArry[0]
     }else if(appKey.indexOf("&") != -1){
        appKey = appKey.split("&")[0]
     }

       config.headers.appKey = appKey
       //setCookie('appKey',router.history.current.params.appKey)
       // if(router.history.current.params.appKey) {
       //   document.cookie = "appKey" + "="+ escape(router.history.current.params.appKey)
       // }

    }
    return config;
  },
  err => {
      return Promise.reject(err);
  });

export default function ajax(url, data = {}, type = 'GET') {
    if(url.indexOf('/notice/noPullList') < 0) {
      let num = parseInt(getCookie("userLocalCycleTime"))
      if (typeof num == "number" && !isNaN(num) && num != undefined) {
        let  expiration = new Date()
        setCookie('userLocalExpiration',parseInt(expiration.getTime()/1000) + num)
      }
    }

    return new Promise((resolve, reject) => {
        let promise;
        // 1. 执行异步ajax请求
        if (type === 'GET') { // 发GET请求
            promise = axios.get(url, { // 配置对象
                params: data // 指定请求参数
            })
        } else if (type === 'POST') { // 发POST请求
            promise = axios.post(url, data)
        } else if (type === 'PUT') { // 发POST请求
            promise = axios.put(url, data)
        } else if(type === 'DOWNLOAD'){
            promise = axios.get(url, {
                params: data,
                responseType:"blob"
            });
        } else if(type === 'download'){
            promise = axios.post(url,data,{
                responseType:"blob"
            });
        } else {
            console.error('暂不支持的请求类型');
            return;
        }
        // 2. 如果成功了, 调用resolve(value)
        promise.then(response => {
            if(type === 'DOWNLOAD'||type === 'download'){
                resolve(response)
            }else{
                response = response.data;
                if (response.code == 500) {
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: response.message,
                        colorType: 'error'
                    })
                    // message.error(response.message);
                } else if (response.code == 0) {
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: response.message,
                        colorType: 'error'
                    })
                    // message.error(response.message);
                    resolve(response);
                }else if([200,201,202,203,302,401,413,404,422,507,509,511,512,1014].includes(response.code)) {
                    resolve(response);
                }else{
                    resolve(response);
                }
            }

        }).catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        if (error.response.data.message) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: error.response.data.message,
                                colorType: 'error'
                            })
                            // message.error(error.response.data.message);
                        }
                        delCookie("userInfo")
                        delCookie("outRemindTime")
                        delCookie("userEditPwd")
                        delCookie("noticePullInterval")
                        delCookie("userLocalCycleTime")
                        delCookie("userLocalExpiration")
                        if(IsIPMode()) {
                            router.push({
                                path: '/login?appKey='+ router.app._route.query.appKey
                            })
                        }else{
                            router.push({
                                path: '/login'
                            })
                        }
                        return;
                    case 302:
                        // let redirectUrlPath = window.location.href.match(/redirectUrl=(\S*)/)
                        //
                        // if(!redirectUrlPath) {
                           window.open(error.response.data.redirectUrl,'_self')
                        // }else{
                        //     redirectUrl()
                        // }
                        return;
                    case 403:
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: "策略阻止本请求",
                            colorType: 'error'
                        })
                        // message.error('策略阻止本请求');
                        return;
                    case 404:
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: "请求错误，请稍后再试",
                            colorType: 'error'
                        })
                        // message.error('请求错误，请稍后再试');
                        return;
                    default:
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: error.message,
                            colorType: 'error'
                        })
                        // message.error( error.message);
                        return;
                }
            }
            // console.error('请求出错了: ' + error.message);
        })
    })
}


function redirectUrl(){
    let urls = decodeURIComponent(window.location.href.match(/redirectUrl=(\S*)/)[1]) // 获取外部http所有信息
    let str = '' //处理后的数据集合
    if(urls.indexOf("?") > -1) { // 判断是否有参数
        let num1 = urls.split("?")[0] // 域名地址
        let num2 = urls.split("?")[1] // 所有的参数集合
        // 判断是否有第二个参数
        if (num2.indexOf("&") > -1) {
            for (let item of num2.split("&")) {
                if (item.indexOf("=") > -1) {
                    let y1 = item.slice(0, item.indexOf("="))
                    // 参数编码
                    let y2 = encodeURIComponent(item.slice(item.indexOf("=")+1))
                    let y3 = y1+'='+y2+"&"
                    str += y3
                }
            }
            str = num1 +'?'+ str.slice(0, str.length-1)
        } else {
            // 一个参数直接拼接
            let y1 = num2.slice(0, num2.indexOf("="))
            let y2 = encodeURIComponent(num2.slice(num2.indexOf("=")+1))
            str = num1 +'?'+ y1+'='+y2
        }
    } else {
        str = urls
    }
    window.open(str, "_self")

}
